module.exports = __webpack_public_path__ + "img/logo.979143d9.webp";